import React from 'react'
import { useSelector } from 'react-redux'
import { MULTIPATH_MODE_TRAIN } from '../../../store/itinerary/itinerary.constants'
import { selectCurrentMode } from '../../../store/itinerary/itinerary.selectors'
import { PUB_TAG } from '../../analytics/PublisherTags.tags'
import { TAG_MULTIPATH_CTA } from '../../analytics/analytics.tagids.constants'
import TagActionLink from '../../genericComponents/TagActionLink'
import s from '../FakeTrainRoute.less'
import logosncf from '../sncf-connect.png'
import { selectFakeTrainRoute } from './itinerary.specialcases.selectors'

const FakeTrainRoute = () => {
  const currentMode = useSelector(selectCurrentMode)
  const fakeTrainRoute = useSelector(selectFakeTrainRoute)

  if (currentMode !== MULTIPATH_MODE_TRAIN || !fakeTrainRoute) return <></>

  return (
    <TagActionLink
      tagInfo={{
        provider: fakeTrainRoute.provider,
        tag: PUB_TAG.PUB_MULTIPATH_TRAIN_NO_RESULT,
      }}
      shouldTagImpression={true}
      type={TAG_MULTIPATH_CTA}
      key="fakeTrainRoute"
      href="https://clk.tradedoubler.com/click?p=277239&a=3194460&g=23721688&epi=&url=https://www.sncf-connect.com/home?&eaf-publisher=mappy&eaf-name=part_fr_conv_mappy-blocgenerique-_comp_filrouge_tr-multiproduit_fr_mk_201704&eaf-creative=creative&eaf-creativetype=1x1&eseg-name=id-affilie&eseg-item=%5Btd_affiliate_id%5D&tduid=%5Btd_guid%5D"
      targetBlank
      nofollow
    >
      <div className={s.container}>
        <img src={logosncf} className={s.logo} alt="SNCF Connect" />
        <p className={s.text}>
          Pour toutes vos envies de voyages... Pensez au train ! &nbsp;
          <span className={s.link}>Horaires et prix sur SNCF Connect</span>
        </p>
      </div>
    </TagActionLink>
  )
}

export default FakeTrainRoute
